<div *ngIf="(vm$ | async) as vm">    
    <!-- styles.scss wouldn't override the global <style> for some reason, this was the only way to do it for the drop items under the avatar-->
    <style>
        .avatar.dropdown .dropdown-menu.dropdown-ins .dropdown-item:hover {
            background-color: #98cf4d !important;
            box-shadow: 0 5px 11px #0000002e,0 4px 15px #00000026;
            border-radius: .125rem;
        }
    </style>
    <header id="pageheader" class="mb-5">

        <!-- Sidebar navigation -->
        <mdb-side-nav #sidenav [fixed]="false" class="rtr-gradient" >

            <mdb-navbar-brand class="pb-3">
                <li>
                    <div class="logo-wrapper waves-light text-center" style="background-image: url(./assets/RTR_logo_digital.png); background-size: 50%; background-position: center center; background-repeat: no-repeat;">
                        <a class="logo navbar-brand" style="color: white; " (click)="sidenav.hide()" [routerLink]="['/']">
                            <button type="button" class="close" aria-label="Close" (click)="sidenav.hide()"
                                style="padding-right: 10px; padding-top: 5px; color: rgb(255, 255, 255, .56)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </a>
                    </div>
                </li>
                <!--/. Logo -->
            </mdb-navbar-brand>

            <div>
                <links *ngIf="vm.isLoggedIn">

                    <!-- Side navigation links -->
                    <li>
                        <ul class="collapsible collapsible-accordion">
                            <mdb-squeezebox [multiple]="false" aria-multiselectable="false">

                                <mdb-item *ngFor="let nl of vm.navLinks">
                                    <mdb-item-head *ngIf="nl.routerLink; else elseItemHead" mdbWavesEffect
                                        class="no-collase" routerLink="{{nl.routerLink}}" (click)="sidenav.hide()">
                                        {{nl.name}}
                                    </mdb-item-head>
                                    <ng-template #elseItemHead>
                                        <mdb-item-head mdbWavesEffect>{{nl.name}}</mdb-item-head>
                                    </ng-template>

                                    <mdb-item-body *ngIf="nl.pages">
                                        <ul>
                                            <li *ngFor="let np of nl.pages">
                                                <a *ngIf="np.routerLink" (click)="sidenav.hide()"
                                                    routerLink="{{np.routerLink}}" class="waves-effect"
                                                    mdbWavesEffect>{{np.name}}</a>
                                                <a *ngIf="np.url" target="_blank" (click)="sidenav.hide()"
                                                    href="{{np.url}}" class="waves-effect"
                                                    mdbWavesEffect>{{np.name}}</a>
                                            </li>
                                        </ul>
                                    </mdb-item-body>
                                </mdb-item>
                            </mdb-squeezebox>

                        </ul>
                    </li>
                    <!--/. Side navigation links -->
                </links>
            </div>
            <div class="text-center mt-3">
                <small>{{vm.displayVersion}}</small><small *ngIf="vm.displayEnv" class="pl-2">({{vm.displayEnv}})</small>
            </div>

            <div class="sidenav-bg mask-strong"></div>
        </mdb-side-nav>
        <!--/. Sidebar navigation -->

        <mdb-navbar SideClass="navbar fixed-top navbar-expand-lg scrolling-navbar navbar-toggleable-md double-nav rtr-gradient-light"
            [containerInside]="false">

            <navlinks class="navbar-container">
                <!-- SideNav slide-out button -->
                <div class="float-left" >
                    <a (click)="sidenav.show()" class="button-collapse hidden-nav-button-collapse">
                        <i class="fa fa-bars rtr-text-green-bold"></i>
                    </a>
                </div>
                <!--/. SideNav slide-out button -->
            </navlinks>

            <mdb-navbar-brand>
                <!-- Breadcrumb-->
                <div class="breadcrumbs breadcrumbs-hidden-nav breadcrumb-dn mr-auto">
                    <a [routerLink]="['/']" target="_self" itemprop="url">
                        <img src="./assets/RTR_logo_digital.png" style="height: 48px;">    
                    </a>

                    <!-- <a class="logo navbar-brand" routerLink="/">
                        <strong>{{vm.displayTitle}}

                        </strong>
                    </a> -->
                </div>
            </mdb-navbar-brand>

            <navlinks (click)="sidenav.hide()">
                <div class="breadcrumbs-hidden-nav breadcrumb-dn text-center" style="width: 100%;">
                    <span class="h5">RTR - Wealth Calculator</span>
                </div>
                <ul *ngIf="vm.isLoggedIn"
                    class="nav navbar-nav ml-auto nav-flex-icons ie-double-nav ie-hidden-double-nav">

                    <li class="nav-item avatar dropdown" mdbDropdown>
                        <!--Trigger-->
                        <a mdbDropdownToggle color="indigo" class="dropdown-toggle waves-light" mdbWavesEffect>
                            <img src="/assets/user-32x32.png" class="img-fluid rounded-circle z-depth-0">

                            <span class="pl-2 rtr-text-green-bold">{{vm.userName}}</span>
                        </a>


                        <!--Menu-->
                        <!-- todo... need to remove alignment class when collapsed -->
                        <div class="dropdown-menu dropdown-ins dropdown-menu-right">
                            <!-- todo... add settings later -->
                            <!-- <a class="dropdown-item" routerLink="/settings">Settings</a>
                            <div class="divider dropdown-divider"></div> -->
                            <a class="dropdown-item" (click)="logout()">Logout</a>
                        </div>
                    </li>
                </ul>
            </navlinks>
        </mdb-navbar>

    </header>

    <main class="pt-4 px-3 px-md-5">

        <div class="pt-3" style="margin-left:auto; margin-right:auto;max-width: 1280px;">
            <!-- routing -->
            <router-outlet></router-outlet>
        </div>
    </main>
</div>

